<template>
  <section class="product_a">
    <div class="a_img" :class="imgClass">
      <img v-for="(src, index) in imgSrc" :key="index" class="scroll-fade-in-f" :src="src" alt="brand_img" />
    </div>

    <div class="a_txt" :class="txtClass">
      <img src="https://img.davich.com/image/sub/product/icon-product-01.png" alt="product_line_a" />
      <img class="product_logo scroll-fade-in-f scroll-delay-1" :src="logoSrc" alt="brand_logo" />
      <p class="scroll-fade-in-f scroll-delay-2" v-html="content"></p>
      <a :href="outlinkUrl" target="_blank" class="el-btn scroll-fade-in-f scroll-delay-3">자세히 보기</a>
    </div>
  </section>
</template>

<script>
export default {
  props: ["companyData"],
  data() {
    return {
      imgClass: "",
      txtClass: "",
      imgSrc: [],
      logoSrc: "",
      content: "",
      outlinkUrl: "",

      i: 0,
    };
  },

  methods: {
    // 시작 좌측용 A 구간 고정 모션---------------------------------------------------------------------
    scrollEvent() {
      const imgClass = this.imgClass;
      const txtClass = this.txtClass;

      var pds = document.documentElement.scrollTop; // 현재 스크롤 위치값

      var contA = document.querySelector(`.${imgClass}`); // 이미지 A 구역
      var contAw = contA.offsetWidth; // A구역의 width 값 저장
      var txtA = document.querySelector(`.${txtClass}`); // 텍스트 A 구역

      var tA = contA.getBoundingClientRect().top + window.scrollY; // 이미지의 시작점 Y값
      var bA = contA.getBoundingClientRect().bottom + window.scrollY - contAw; // 이미지의 끝점 Y값 - 이미지 Width 값

      var hH = document.querySelector("header").offsetHeight; // 헤드의 높이를 저장 / 포지션 top 용
      var txtAX = txtA.getBoundingClientRect().left + window.scrollX - 200; // 텍스트 A 구역의 좌측 여백값 저장 / 포지션 left 용

      var contAlength = contA.getElementsByTagName("img").length; // 이미지 A 구역의 이미지 갯수 값 저장
      var contAH = (contAlength - 1) * contAw; // 이미지 최대 갯수-1, 곱하기 이미지 폭

      if (pds >= tA && pds < bA) {
        if (this.i == 0) {
          // 텍스트박스가 스크롤 영역에 있을때
          txtA.setAttribute("style", "position:fixed; top:" + hH + "px; left:" + txtAX + "px"); // fixed
          this.i++;
        }
      }
      if (pds > bA) {
        if (this.i > 0) {
          // 텍스트박스가 스크롤 영역 하단으로 벗어날때
          txtA.setAttribute("style", "position:relative");
          txtA.setAttribute("style", "transform:translate(0," + contAH + "px)");
          this.i = 0;
        }
      }
      if (pds < tA) {
        if (this.i > 0) {
          // 텍스트박스가 스크롤 영역 상단으로 벗어날때
          txtA.setAttribute("style", "position:relative");
          txtA.setAttribute("style", "transform:translate(0,0)");
          this.i = 0;
        }
      }
    },
  },

  created() {
    const self = this;
    self.imgClass = "a" + this.companyData.id + "img";
    self.txtClass = "a" + this.companyData.id + "txt";
    self.imgSrc = this.companyData.imgSrc;
    self.logoSrc = this.companyData.logoSrc;
    self.content = this.companyData.content;
    self.outlinkUrl = this.companyData.outlinkUrl;
  },
  mounted() {
    document.addEventListener("scroll", this.scrollEvent);
  },

  destroyed() {
    document.removeEventListener("scroll", this.scrollEvent);
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";
@import "~@/assets/scss/helpers/richText";

// 브랜드A - (이미지 왼쪽정렬 형태)

.product_a {
  padding-top: 70px;
  padding-bottom: 220px;
  display: flex;
  justify-content: flex-start;
  .a_img {
    width: 600px;
    display: block;
    img {
      width: 100%;
      display: block;
    }
  }
  .a_txt {
    @include rich-text-format; // 브랜드 설명(v-html) 서식 복구
    position: relative;
    margin-left: 200px;
    width: 600px;
    img {
      display: flex;
    }
    .product_logo {
      margin: 50px 0;
    }
    p {
      line-height: 30px;
      font-size: 18px;
      letter-spacing: -0.54px;
      margin-bottom: 150px;
    }
  }
}
</style>
